import React from 'react';

export function OperationalObject({
  personId = 'ID:--',
  personName = 'NN',
  gapDescription,
  nextAction,
  statusLabel,
  statusVariant = 'none',
  className = '',
  compact = false
}) {
  
  return (
    <article className={`bg-surface border border-line rounded-[12px] ${compact ? 'p-4 md:p-5 min-h-[auto]' : 'p-5 md:p-7 min-h-[280px] md:min-h-[320px]'} flex flex-col justify-between w-full shadow-sm ${className}`}>
      
      <div className="flex justify-between items-center w-full gap-3">
        <div className="flex items-center gap-3">
          <div className="flex flex-col">
            <span className="font-mono text-[13px] font-medium text-slate-dark tracking-wide">{personName} &middot; {personId}</span>
          </div>
        </div>
      </div>

      <div className={`flex-1 flex items-center ${compact ? 'py-2' : 'py-3'}`}>
        <h3 className={`${compact ? 'text-[18px]' : 'text-[20px] md:text-[24px]'} font-medium text-ink leading-[1.3]`}>
          {gapDescription}
        </h3>
      </div>

      <div className={`${compact ? 'pt-4 mt-2' : 'pt-6 mt-auto'} border-t border-line flex items-center justify-between gap-4 flex-wrap`}>
        
        {nextAction ? (
          <div className="flex flex-col gap-1">
            <span className="text-[11px] font-medium text-ink-soft/70 uppercase tracking-widest">Acción requerida</span>
            <span className="text-[13px] font-bold text-brand uppercase tracking-widest">{nextAction}</span>
          </div>
        ) : (
          <div className="flex flex-col gap-1">
            <span className="text-[11px] font-medium text-ink-soft/70 uppercase tracking-widest">Próximo paso</span>
            <span className="text-[13px] font-bold text-ink uppercase tracking-widest">Reevaluar reglas</span>
          </div>
        )}
        
        {statusLabel && (
          <div className="flex flex-col items-end gap-1">
            <span className="text-[11px] font-medium text-ink-soft/70 uppercase tracking-widest">Estado</span>
            <span
              className={[
                'inline-flex items-center px-2 py-1 rounded-md text-[11px] font-bold tracking-widest uppercase border',
                statusVariant === 'evidence'
                  ? 'bg-resolve/10 text-resolve border-resolve/20'
                  : statusVariant === 'waiting'
                  ? 'bg-amber-50 text-amber-700 border-amber-200'
                  : statusVariant === 'open'
                  ? 'bg-brand/10 text-brand border-brand/20'
                  : 'bg-paper text-ink-soft border-line',
              ].join(' ')}
            >
              {statusLabel}
            </span>
          </div>
        )}
      </div>

    </article>
  );
}
